/* Han motion adapted to native Shopify controls. No commerce handlers replaced. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const ease = 'cubic-bezier(.16,1,.3,1)';
  const seen = new WeakSet(), running = new Set(), targets = new Set(), cleanups = new Map();
  const within = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  const animate = (el, frames, options) => {
    if (!el || reduced.matches) return;
    const a = el.animate(frames, {easing: ease, ...options});
    running.add(a); a.finished.catch(() => {}).finally(() => running.delete(a));
  };
  const groups = [];
  const observers = groups.map(g => typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    observers[groups.indexOf(g)]?.unobserve(entry.target); targets.delete(entry.target);
    animate(entry.target,g.y ? [{opacity:0,transform:`translateY(${g.y}px)`},{opacity:1,transform:'translateY(0)'}] : [{opacity:0},{opacity:1}],{duration:g.duration});
  }),g));
  function init(root=document) {
    groups.forEach((g,i) => within(root,g.selector).forEach(el => {
      if(seen.has(el)) return; seen.add(el); if(!reduced.matches) {observers[i]?.observe(el);targets.add(el);}
    }));

  }
  function header() {
    if(document.body.dataset.hanPage==='index'||document.body.hasAttribute('data-han-story-page')) return; // Source header bridge owns homepage motion.
    const section=document.querySelector('.shopify-section-header');
    if(!section||section.dataset.hanExperience) return;
    section.dataset.hanExperience='true';
    const controller=new AbortController(), signal=controller.signal;
    const hero=document.querySelector('.han-hero'),home=document.body.dataset.hanPage==='index';
    if(home) animate(section,[{opacity:0,transform:'translateY(-12px)'},{opacity:1,transform:'translateY(0)'}],{duration:900});
    let scrollCompact=!hero,frame=0;
    const update=()=>{
      frame=0;
      const threshold=hero?hero.offsetTop+hero.offsetHeight*.8:0;
      if(scrollY>=threshold)scrollCompact=true;
      else if(scrollY<threshold-24)scrollCompact=false;
      const open=!!section.querySelector('.burger-menu--open,.menu-drawer-container[open],.han-content-menu[open]');
      document.body.classList.toggle('han-menu-open',open);
      document.body.classList.toggle('han-nav-compact',scrollCompact||open);
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};
    const mutation=new MutationObserver(schedule); mutation.observe(section,{subtree:true,attributes:true,attributeFilter:['class','open']});
    addEventListener('scroll',schedule,{passive:true,signal});addEventListener('resize',schedule,{passive:true,signal});
    /* Add keyboard entry/exit to the existing native hover menu methods. */
    section.querySelectorAll('burger-menu').forEach(menu=>{
      const trigger=menu.querySelector('.burger-menu__hover--open-btn,.burger-menu__toggle--open-btn');
      if(!trigger)return;
      let keyboardClosed=false;
      trigger.addEventListener('mouseenter',event=>{if(keyboardClosed)event.stopImmediatePropagation()},{capture:true,signal});
      addEventListener('pointermove',event=>{if(event.movementX||event.movementY)keyboardClosed=false},{passive:true,signal});
      trigger.addEventListener('pointerdown',()=>{keyboardClosed=false},{signal});
      trigger.addEventListener('keydown',event=>{
        if(event.key!=='ArrowDown')return;
        event.preventDefault();keyboardClosed=false;
        if(!menu.querySelector('.burger-menu--open'))menu.open?.(event);
        requestAnimationFrame(()=>[...menu.querySelectorAll('.burger-menu__wrapper a[href],.burger-menu__wrapper button')].find(el=>el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden')?.focus());
      },{signal});
      menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.querySelector('.burger-menu--open')){keyboardClosed=true;menu.close?.(event);trigger.focus()}},{signal});
    });
    update();
    cleanups.set(section,()=>{controller.abort();mutation.disconnect();cancelAnimationFrame(frame);delete section.dataset.hanExperience;document.body.classList.remove('han-menu-open','han-nav-compact')});
  }
  reduced.addEventListener('change',()=>{if(reduced.matches){observers.forEach(o=>o?.disconnect());running.forEach(a=>a.cancel());running.clear()}});
  document.addEventListener('shopify:section:unload',event=>{
    targets.forEach(el=>{if(event.target.contains(el)){observers.forEach(o=>o?.unobserve(el));targets.delete(el);seen.delete(el)}});
    running.forEach(a=>{if(event.target.contains(a.effect?.target))a.cancel()});
    cleanups.forEach((cleanup,el)=>{if(event.target.contains(el)){cleanup();cleanups.delete(el)}});
  });
  init();header();
  document.addEventListener('shopify:section:load',event=>{init(event.target);header()});
})();
